import CurrentOrganization from './CurrentOrganization'

export default CurrentOrganization



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/CurrentOrganization/index.js